export default __webpack_public_path__ + "static/media/7_2_logo.fb90f6dc.png";